<template>
  <ClientOnly>
    <!-- @vue-ignore -->
    <VueSvgLocalIcon
      v-if="importedSvg"
      class="svg-icon-wrapper"
      v-bind="merge({}, props, $attrs)"
      :data="importedSvg"
    />
  </ClientOnly>
</template>

<script setup lang="ts">
import {
  type Icon,
  VueSvgIcon as VueSvgLocalIcon,
  type Props as SvgIconProps,
} from "@yzfe/vue3-svgicon";
import isArray from "lodash-es/isArray";
import isObject from "lodash-es/isObject";
import merge from "lodash-es/merge";

defineOptions({
  inheritAttrs: false,
});
interface Props extends SvgIconProps {}
const props = withDefaults(defineProps<Props>(), {
  width: 24,
  height: 24,
  fill: true,
});

const importedSvg = ref<Icon>();
watch(
  [() => props.data],
  ([propsData]) => {
    if (isObject(propsData) && !isArray(props.data)) {
      importedSvg.value = propsData as Icon;
    }
  },
  {
    immediate: true,
    deep: true,
  },
);
</script>

<style lang="scss">
.svg-icon-wrapper {
  line-height: 0.9;
}
</style>
